export enum FormAlignmentsEnum {
  left = 'left',
  center = 'center',
  right = 'right',
}
